import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=060cf312&scoped=true&"
import script from "./MenuLink.vue?vue&type=script&lang=js&"
export * from "./MenuLink.vue?vue&type=script&lang=js&"
import style0 from "./MenuLink.vue?vue&type=style&index=0&id=060cf312&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cf312",
  null
  
)

export default component.exports